import { Component, inject, NgZone, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { TranslateService } from "@ngx-translate/core";
import { filter } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiService } from "src/services/api.service";
import { NotificationsService } from "src/services/notifications.service";
import { UserStorageService } from "src/services/user-storage.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["../style/nordea/main.scss"],
	standalone: false,
})
export class AppComponent implements OnInit {
	private apiService = inject(ApiService);
	private router = inject(Router);
	private zone = inject(NgZone);
	private notificationsService = inject(NotificationsService);
	private translate = inject(TranslateService);
	private userStorageService = inject(UserStorageService);

	title = "Vicorda";

	ngOnInit(): void {
		this.translate.use(this.userStorageService.getLanguage().shortcode);

		this.router.events
			.pipe(filter((e) => e instanceof NavigationEnd))
			.subscribe((e) => {
				const isFaceScan = (e as NavigationEnd).urlAfterRedirects.startsWith(
					"/face-scan",
				);
				document.body.classList.toggle("page-face-scan", isFaceScan);
			});

		if (Capacitor.isNativePlatform()) {
			this.router.navigate(["link/mobile"]);
			console.log("Navigating to link/mobile");
			return;
		}

		this.apiService.CheckLogin();

		if (Capacitor.getPlatform() !== "web") {
			this.initializeMagicLinks();

			if (this.apiService.GetTicket()) {
				this.notificationsService.initialize();
			}
		}
	}

	initializeMagicLinks() {
		App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
			this.zone.run(() => {
				const domain = environment.Domain;

				const pathArray = event.url.split(domain);
				const appPath = pathArray.pop();
				if (appPath) {
					this.router.navigateByUrl(appPath);
				}
			});
		});
	}
}
